import {today} from "../../lib/utilities";

export default {
    date: true,
    dateMax: today(),
    datePattern: ['m', 'd', 'Y']
}